module.exports = __webpack_public_path__ + "static/media/LAZ_05.a482f755.jpg";